import CrmCenteredTitle from '../../components/CrmCenteredTitle';
import React from 'react';
import CrmLayout from '../../components/CrmLayout';
import ProjectForm from './ProjectForm';
import { MUTATION_CREATE_PROJECT } from '../../graphql/project';
import { toProject } from '../../routes';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import _ from 'lodash';
import { normaliseColor } from '../../helpers/color';

export default function ProjectNew() {

    const navigate = useNavigate();
    const [createProject, { loading }] = useMutation(MUTATION_CREATE_PROJECT)

    const onFinish = async (input) => {
        const data = {
            ...input,
            logo: input.logo ? input.logo.id : undefined,
            cover: input.cover ? input.cover.id : undefined,
            color: normaliseColor(input.color),
            levels: _.map(input.levels, (level) => ({
                ...level,
                color: normaliseColor(level.color),
            })),
        }
        await createProject({
            variables: {
                data: data
            },
            onCompleted: (res) => {
                navigate(toProject(res.createProject.data.id))
            }
        })
    };

    return (
        <CrmLayout>

            <CrmCenteredTitle title={'Новый проект'}/>

            <ProjectForm onFinish={onFinish} loading={loading}/>

        </CrmLayout>
    )
}